import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import { SideBar } from "../../../components/CattleMap/SideBarMenu/Index";
import { EditOnboardingProvider } from "../../../contexts/EditOnboardingContext";
import { useFilter } from "../../../hooks/useFilter";
import { Index } from "../Maps/Template/Index";
import { ShowData } from "../ShowData";
import "./styles.css";
import { SystemManager } from "../ShowData/SystemManager";

export function PaddocksMapIndex() {
  const { sideBarOptionSelected } = useFilter();
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  useEffect(() => {
    const handleSidebarToggle = (event: CustomEvent) => {
      setSidebarExpanded(event.detail.isOpen);
    };

    window.addEventListener('sidebarToggle', handleSidebarToggle as EventListener);
    
    return () => {
      window.removeEventListener('sidebarToggle', handleSidebarToggle as EventListener);
    };
  }, []);

  return (
    <section className={`paddocksmap__container--template ${sidebarExpanded ? 'sidebar-expanded' : 'sidebar-collapsed'}`}>
      <SideBar />
      <main style={{ background: "#F1F1F1" }}>
        {sideBarOptionSelected == "MAPA" || sideBarOptionSelected == "DASHBOARD" ? (
          <Index>
            <Outlet />
          </Index>
        ) : (
          <EditOnboardingProvider>
            <SystemManager />
          </EditOnboardingProvider>
        )}
      </main>
    </section>
  );
}
